import { Stack, Tooltip, UnstyledButton } from "@mantine/core";

import { MenuIcon } from "@/components/Icons/MenuIcon";
import { MenuOption } from "@/types/pages/dashboard";
import { SideBarOptionIcon } from "./components/SideBarOptionIcon";
import { useNavigate } from "react-router-dom";
import styles from "./styles.module.scss";

interface DashboardSidebarProps {
  menuOptions: MenuOption[];
  isMenuOpened: boolean;
  changeIsMenuOpened: (option?: MenuOption) => void;
  selectedMenuOption: string;
  changeSelectedMenuOption: (option: string) => void;
}

export function DashboardSidebar({
  menuOptions,
  isMenuOpened,
  changeIsMenuOpened,
  selectedMenuOption,
  changeSelectedMenuOption,
}: DashboardSidebarProps) {
  const navigate = useNavigate();

  const handleClickOption = (option: MenuOption) => {
    changeSelectedMenuOption(option.label);

    if (option.link) {
      navigate(option.link);
    }

    changeIsMenuOpened(option);
  };

  return (
    <Stack align="center" className={styles.sidebar} gap={5}>
      <Tooltip
        label={isMenuOpened ? "Fechar Menu" : "Abrir Menu"}
        withArrow
        position="right"
      >
        <UnstyledButton
          className={styles.closeMenuIconButton}
          onClick={() => changeIsMenuOpened()}
        >
          <MenuIcon color="#FFF" />
        </UnstyledButton>
      </Tooltip>

      {menuOptions.map((option, i) => (
        <SideBarOptionIcon
          key={i}
          option={option}
          selectedMenuOption={selectedMenuOption}
          handleClick={() => handleClickOption(option)}
        />
      ))}
    </Stack>
  );
}
